import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { DynamicFieldsService } from '../dynamic-fields.service';
import * as _ from 'lodash';

@Component({
    selector: 'dynfield-checkbox',
    template: require('./dynamic-fields.checkbox.component.html')
})
export class DynamicFieldCheckboxComponent implements OnInit, OnChanges {
    @Input() version: any;
    @Input() field: any;
    @Input() fieldsOptions: any;
    @Input() fieldError: any;
    @Input() allowUpdate: any;

    isRequired: boolean;
    fieldElements: any[] = [];
    error: any;

    constructor(private dynamicFieldsService: DynamicFieldsService) {}

    ngOnInit() {
        this.isRequired = this.dynamicFieldsService.isRequired(this.field);
        this.fieldElements = _.clone(_.get(this, 'fieldsOptions[' + this.field.alias + '].fieldElements', []));
        this.error = this.dynamicFieldsService.setError(this.fieldError, this.field);
        this.setDefaultValue();
        this.field.fieldData = _.reduce(this.field.fieldData, (carry, el) => {
            const ret = _.find(this.fieldElements, { id: el.id });
            if (ret) {
                ret.checked = true;
                carry.push({ id: ret.id });
            }
            return carry;
        }, []);
        this.field.fieldData = this.getSelectedElements(this.fieldElements);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.error = this.dynamicFieldsService.setError(
            changes?.fieldError?.currentValue, this.field
        );
    }

    isSelected(element) {
        return !_.isEmpty(_.find(this.field.fieldData, {id: element.id}));
    }

    setDefaultValue() {
        if ((_.isEmpty(this.field.fieldData) || (_.get(this.field, 'fieldData[0].id', 100) === 100))
            && this.field.alias !== '') {
            const el = _.find(this.fieldsOptions[this.field.alias].fieldElements, { defaultSelected: true });
            if (el) {
                this.field.fieldData = [el];
            }
        }
    }

    toggleElement(element) {
        if (element.checked) {
            element.checked = false;
        } else {
            element.checked = true;
        }

        this.field.fieldData = this.getSelectedElements(this.fieldElements);
    }

    getSelectedElements(elements) {
        const ret = _.filter(elements, { checked: true });
        return !ret?.length ? [{ id: 100 }] : ret;
    }
}
